import React, { useState } from "react";
import * as styles from "./video.module.scss"
import YouTube from 'react-youtube';

const Video = ({ data }) => {

    const [player, setPlayer] = useState(null)

    const onReady = (event) => {
        setPlayer(event.target)
    }

    const changeTime = (seconds) => {
        player.seekTo(seconds)
        player.playVideo()
    }

    const timestamps = data.timestamps?.map((timestamp, i) => {

        let mins = Math.floor(timestamp.timestamp / 60)
        let seconds = timestamp.timestamp % 60
        seconds = seconds < 10 ? "0" + seconds : seconds

        return (
            <li 
                onClick={ () => changeTime(timestamp.timestamp)} 
                onKeyDown={ () => changeTime(timestamp.timestamp)} 
                key={i}
            >
                {timestamp.text}
                <span>&nbsp;({timestamp.timestamp ? `${mins}:${seconds}` : "0:00"})</span>
            </li>
        )
    })

    return (
        <div 
            className={styles.videoBlock}
            style={{
                paddingTop: `${data.paddingTop}rem`,
                paddingBottom: `${data.paddingBottom}rem`
            }}
        >
            <div className="container">
                <div className="row">
                    <div className="col-lg-8 offset-lg-2">
                        <YouTube 
                            videoId={data.videoId} 
                            className={`${styles.embed_responsive} ${styles.embed_responsive_16by9} ${styles.videoBlock__video}`}
                            onReady={onReady}
                        />

                        {timestamps &&
                            <div className={styles.videoBlock__timestamps}>
                                <ul>
                                    {timestamps}
                                </ul>
                            </div>
                        }
                    </div>
                </div>
            </div>
            
        </div>
    )
}

export default Video